export default __webpack_public_path__ + "static/media/1.8c357691.jpeg";